function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'red': 'rgb(239, 0, 0)','blue': 'rgb(0, 0, 238)','reflex-blue': 'rgb(0, 20, 137)','hazel': 'rgb(142, 118, 24)','black': 'rgb(0, 0, 0)','kitt': 'rgb(105, 105, 105)','coccinella': 'rgb(196, 30, 58)','watermelon': 'rgb(252, 108, 133)','thunder-grey': 'rgb(138, 141, 143)','ebony': 'rgb(85, 93, 80)','shocking-orange': 'rgb(255, 102, 0)','astral-blue': 'rgb(79, 134, 247)','dark-blue': 'rgb(0, 0, 139)','shocking-green': 'rgb(102, 255, 0)','phantom': 'rgb(70, 70, 70)','bright-grey': 'rgb(179, 179, 179)','phantom-melange': 'rgb(115, 115, 115)','lightning-coral': 'rgb(255, 111, 97)','flamengo': 'rgb(237, 28, 36)','black-olive': 'rgb(59, 60, 54)','real-white': 'rgb(255, 255, 255)','alpine-blue': 'rgb(93, 138, 168)','pink-glow': 'rgb(255, 102, 204)','kobalt': 'rgb(0, 71, 171)','mint': 'rgb(152, 255, 152)','frozen': 'rgb(170, 214, 255)','cockatoo-stripes': 'rgb(240, 230, 140)','cocktails': 'rgb(255, 182, 193)','dark-blue-stripes': 'rgb(0, 0, 139)','doodles': 'rgb(169, 169, 169)','pinstripe-palmtrees': 'rgb(34, 139, 34)','surfer': 'rgb(0, 105, 148)','tompouce': 'rgb(255, 183, 197)','tonal-hawaiian-flowers-aop': 'rgb(255, 105, 180)','orange-clown-fish': 'rgb(255, 165, 0)','bullseye': 'rgb(178, 34, 34)','dark-stone-melange': 'rgb(90, 90, 90)','black-heart': 'rgb(10, 10, 10)','black-white-star': 'rgb(136, 136, 136)','cloud-dancer': 'rgb(224, 255, 255)','collored-heart': 'rgb(255, 20, 147)','star': 'rgb(255, 255, 0)','aangeschoten-wild': 'rgb(85, 87, 187)','abyss-blue': 'rgb(167, 52, 194)','acid-yellow': 'rgb(197, 98, 203)','atjevoordesfeer': 'rgb(116, 9, 200)','aufwiederschnitzel': 'rgb(77, 233, 1)','blue-flowers': 'rgb(236, 96, 201)','blue-grape': 'rgb(67, 233, 36)','cashmere-blue': 'rgb(181, 230, 186)','cloud-grey-melange': 'rgb(208, 148, 245)','coronet-blue': 'rgb(250, 101, 196)','fiery-coral': 'rgb(137, 10, 107)','hay': 'rgb(134, 244, 183)','holy-aperoli': 'rgb(223, 230, 100)','iceberg': 'rgb(132, 157, 147)','icy-but-spicy': 'rgb(209, 82, 235)','ink-blue': 'rgb(49, 98, 80)','latrelatie': 'rgb(82, 10, 24)','lekker-tirollebollen': 'rgb(227, 158, 170)','midnight-blue': 'rgb(176, 242, 176)','ofjewurstlust': 'rgb(79, 82, 189)','pilsmeister': 'rgb(48, 164, 2)','sandstone': 'rgb(146, 58, 94)','schnaps-du': 'rgb(81, 102, 232)','vermillion': 'rgb(179, 120, 45)','volcano': 'rgb(228, 240, 146)','voor-ieder-wat-pils': 'rgb(195, 216, 152)','zebra-black': 'rgb(112, 251, 230)','zebra-hay': 'rgb(19, 207, 68)',};

    this.images = {};

    this.triggers = ['color','colour',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
